import { ArrowLeft, Loader2 } from "lucide-react";
import { Link, useParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useWorksite } from "@/features/canteiros/hooks/use-worksite.ts";
import { useActiveObra } from "@/features/stages/hooks/use-active-obra.ts";
import { HolidaysPanel } from "@/features/time-settings/components/holidays-panel";
import { TimeSettingsForm } from "@/features/time-settings/components/time-settings-form";
import { useTimeSettings } from "@/features/time-settings/hooks/use-time-settings";

export function JornadaPage() {
	const { obra: obraKey } = useParams();
	const { obra } = useActiveObra();
	const { data: worksite } = useWorksite(obra?.canteiroId);
	const settings = useTimeSettings();

	function body() {
		if (settings.isPending) {
			return (
				<div className="page-loading">
					<Loader2 />
				</div>
			);
		}
		if (settings.isError) {
			return (
				<Card>
					<CardContent className="card-state">
						<p>Não foi possível carregar a jornada desta obra.</p>
						<Button variant="outline" onClick={() => settings.refetch()}>
							Tentar novamente
						</Button>
					</CardContent>
				</Card>
			);
		}
		return (
			<>
				<TimeSettingsForm
					settings={settings.data}
					timezone={worksite?.timezone}
				/>
				<HolidaysPanel />
			</>
		);
	}

	return (
		<div className="jornada-page">
			<Link
				to={`/${obraKey}/configuracoes-da-obra`}
				className="jornada-page__back"
			>
				<ArrowLeft />
				Configurações da obra
			</Link>
			<div className="page-header">
				<div>
					<h1 className="page-title">Jornada e horas extras</h1>
					<p className="page-subtitle">
						Horário de trabalho, percentuais de hora extra e feriados do
						canteiro.
					</p>
				</div>
			</div>

			{body()}
		</div>
	);
}
